/** @jsxImportSource theme-ui */
import sprite from "../../../public/sprites.svg";

export interface SpriteProps {
  ariaLabel?: string;
  className?: string;
  icon: string;
  color?: string;
}

export const Sprite = ({ ariaLabel, className, icon, color }: SpriteProps) => {
  const iconName = icon.toLowerCase();

  return (
    <svg
      aria-label={ariaLabel}
      className={className}
      sx={{
        color: color ? color : "inherit",
        fill: color ? color : "inherit",
      }}
    >
      <use xmlnsXlink="w3.org/1999/xlink" xlinkHref={sprite + `#${iconName}`} />
    </svg>
  );
};
